<template>
  <div class="calendar-container">
    <div class="month-show">{{monthMap[currentDate.month()] + ' ' + currentDate.year()}}</div>
    <div class="select-btn-wrap">
      <el-button type="text" style="margin-right: 22px" @click="handlePreviousDate">
        <i class="el-icon-arrow-left select-btn"></i>
      </el-button>
      <el-button type="text" @click="handleNextDate">
        <i class="el-icon-arrow-right select-btn"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "month-select",
  components: {},
  props: {
    currentDate: {
      type: Object,
      default: () => {
        return this.$dayjs();
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    monthMap() {
      return [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    },
  },
  methods:{
    handlePreviousDate(){
      this.$emit('previousDate')
    },
    handleNextDate(){
      this.$emit('nextDate')
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .month-show {
    text-align: end;
    min-width: 185px;
    margin-right: 24px;
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
    color: rgb(48, 49, 51);
  }
  .select-btn-wrap {
    display: flex;
    .select-btn {
      font-size: 16px;
      color: rgb(48, 49, 51);
      font-weight: 600;
    }
  }
}
</style>
